import Vue from 'vue'
import VueRouter from 'vue-router'

import Aba from './tabs'
import AtencaoContinuada from './atencao_continuadas'
import Empresa from './empresas'
import Estoque from './estoques'
import Fabricantes from './fabricantes'
import FinalizacaoReceita from './finalizacao_receitas'
import Fornecedores from './fornecedores'
import Grupo from './grupos'
import Familia from './familias'
import Material from './materiais'
import Movimento from './movimentos'
import Paciente from './pacientes'
import Pedido from './pedidos'
import PesquisaMaterial from './pesquisa_material'
import PesquisaUnidade from './pesquisa_unidade'
import Profile from './profile'
import Profissional from './profissionais'
import Receita from './receitas'
import Rota from './rotas'
import SubGrupo from './sub_grupos'
import TipoConselho from './tipo_conselhos'
import TipoMovimentacao from './tipo_movimentacoes'
import TipoProfissional from './tipo_profissionais'
import TipoReceita from './tipo_receitas'
import TipoVeiculo from './tipo_veiculos'
import UnidadeMaterial from './unidade_materiais'
import Unidade from './unidades'
import User from './user'
import Veiculo from './veiculos'
import Assunto from './assuntos'
import Documento from './documentos'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    Aba,
    AtencaoContinuada,
    Empresa,
    Estoque,
    Fabricantes,
    Familia,
    FinalizacaoReceita,
    Fornecedores,
    Grupo,
    Material,
    Movimento,
    Paciente,
    Pedido,
    PesquisaMaterial,
    PesquisaUnidade,
    Profile,
    Profissional,
    Receita,
    Rota,
    SubGrupo,
    TipoConselho,
    TipoMovimentacao,
    TipoProfissional,
    TipoReceita,
    TipoVeiculo,
    UnidadeMaterial,
    Unidade,
    User,
    Veiculo,
    Assunto,
    Documento,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/public/:id?',
      name: 'public',
      component: () => import('@/views/Pedido/Public.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/finalizado',
      name: 'finalizado',
      component: () => import('@/views/Pedido/Finalizado.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const terms = localStorage.getItem('accept_terms');
  const authenticated = localStorage.getItem('token');
  // Try to get from store first, fallback to localStorage
  const userAccessLevel = parseInt(localStorage.getItem('access_nivel') || '6');
  let to_splited = to.path.toString().split('/')
  to_splited = to_splited.filter(part => part !== '')

  // Check authentication
  if (
    !authenticated &&
    (
      !(['/login'].includes(to.path.toString())) &&
      !(['public'].includes(to_splited[0]))
    )
  ) {
    next('/login');
    return true;
  }

  // Check access level for different route groups
  const cadastrosRoutes = [
    '/abas', '/fabricantes', '/familias', '/fornecedores', '/grupos', '/materiais',
    '/profissionais', '/rotas', '/sub_grupos', '/tipo_movimentacoes', '/tipo_profissionais',
    '/tipo_receitas', '/tipo_veiculos', '/unidade_materiais', '/unidades', '/users', '/veiculos'
  ];

  const movimentarRoutes = ['/movimentos'];

  // Only Administrators can access Cadastros
  const isCadastroRoute = cadastrosRoutes.some(route => to.path.startsWith(route));
  if (isCadastroRoute && userAccessLevel !== 6) {
    next('/?access_denied=cadastros');
    return true;
  }

  // Only Administrators and Farmacêuticos can access Movimentar
  const isMovimentarRoute = movimentarRoutes.some(route => to.path.startsWith(route));
  if (isMovimentarRoute && ![6, 2].includes(userAccessLevel)) {
    next('/?access_denied=movimentar');
    return true;
  }

  // Auxiliar de Farmácia cannot create or edit pedidos
  const pedidoCreateEditRoutes = ['/semanal', '/pedidos/add', '/pedidos/suplementar', '/pedidos/rapido'];
  const isPedidoCreateEditRoute = pedidoCreateEditRoutes.some(route => to.path.startsWith(route));
  if (isPedidoCreateEditRoute && userAccessLevel === 3) {
    next('/?access_denied=pedido_criar');
    return true;
  }

  // Supervisor de Enfermagem cannot access certain pedido routes
  const supervisorRestrictedRoutes = ['/semanal', '/pedidos/rapido'];
  const isSupervisorRestrictedRoute = supervisorRestrictedRoutes.some(route => to.path.startsWith(route));
  if (isSupervisorRestrictedRoute && userAccessLevel === 4) {
    next('/?access_denied=supervisor_pedido');
    return true;
  }

  // Supervisor de Enfermagem cannot access Pedidos Baixa Estoque
  const baixaEstoqueRoutes = ['/pedidos-baixa-estoque'];
  const isBaixaEstoqueRoute = baixaEstoqueRoutes.some(route => to.path.startsWith(route));
  if (isBaixaEstoqueRoute && userAccessLevel === 4) {
    next('/?access_denied=baixa_estoque');
    return true;
  }

  next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
